var cache = new Map();
var listeners = {};

var setCache = function setCache(key, cacheTime, data, params) {
  var currentCache = cache.get(key);

  if (currentCache === null || currentCache === void 0 ? void 0 : currentCache.timer) {
    clearTimeout(currentCache.timer);
  }

  var timer = undefined;

  if (cacheTime > -1) {
    // if cache out, clear it
    timer = setTimeout(function () {
      cache["delete"](key);
    }, cacheTime);
  } // trigger listeners


  if (listeners[key]) {
    listeners[key].forEach(function (item) {
      return item(data);
    });
  }

  cache.set(key, {
    data: data,
    params: params,
    timer: timer,
    time: new Date().getTime()
  });
};

var getCache = function getCache(key) {
  return cache.get(key);
};

var subscribe = function subscribe(key, listener) {
  if (!listeners[key]) {
    listeners[key] = [];
  }

  listeners[key].push(listener);
  return function unsubscribe() {
    var index = listeners[key].indexOf(listener);
    listeners[key].splice(index, 1);
  };
};

var clearCache = function clearCache(key) {
  if (key) {
    var cacheKeys = Array.isArray(key) ? key : [key];
    cacheKeys.forEach(function (cacheKey) {
      return cache["delete"](cacheKey);
    });
  } else {
    cache.clear();
  }
};

export { getCache, setCache, subscribe, clearCache };